import { Component, Inject, OnChanges, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { genThumbMediaURI, isMediaInfoPublishable, PropertyMediaInfo } from '../../image';

export interface AdditionalImageDialogInputData {
  imagesToDisplay: PropertyMediaInfo[];
  multiSelect: boolean;
  edpMultimediaURI: string;
  s3BucketImagesUrl: string;
  selectedImageId?: number;
  navigationMessage?: boolean;
  availabilityId?: number;
  translatedData: {
    close: string;
    selectAttachment: string;
    select: string;
    noImagesFound: string;
    navigationMessage?: string;
    addNew?: string;
  };
}

@Component({
  selector: 'additional-image-dialog',
  templateUrl: './add-additional-image-dialog.html',
  styleUrls: ['./add-additional-image-dialog.scss'],
  standalone: false,
})
export class AddAdditionalImageDialogComponent implements OnInit, OnChanges {
  public imagesToDisplay: PropertyMediaInfo[];
  public multiSelect: boolean;
  public edpMultimediaURI: string;
  public imageLocationURI: string;
  public images = [];
  public selectedMediaID: number;
  public selectedMedia: PropertyMediaInfo;
  public navigationMessage: boolean = false;
  public translatedData;
  public availabilityId: number;

  constructor(
    public dialogRef: MatDialogRef<AddAdditionalImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: AdditionalImageDialogInputData,
    private router: Router
  ) {
    this.imagesToDisplay = data.imagesToDisplay;
    this.multiSelect = data.multiSelect;
    this.edpMultimediaURI = data.edpMultimediaURI;
    this.imageLocationURI = data.s3BucketImagesUrl;
    this.selectedMediaID = data.selectedImageId;
    this.translatedData = data.translatedData;
    this.navigationMessage = data.navigationMessage;
    this.availabilityId = data.availabilityId;
    if (this.selectedMediaID) {
      this.selectedMedia = this.imagesToDisplay.find(image => image.id === this.selectedMediaID);
    }
  }
  ngOnInit() {
    if (this.imagesToDisplay.length) {
      this.images = this.imagesToDisplay.map(media => ({
        ...media,
        sanitized_media_path: genThumbMediaURI(this.edpMultimediaURI, this.imageLocationURI, media.media_path),
        publishable: isMediaInfoPublishable(media),
      }));
    }
  }

  ngOnChanges() {}

  public onClose(media?: PropertyMediaInfo | PropertyMediaInfo[]) {
    this.dialogRef.close(media);
  }

  public select() {
    this.onClose(this.selectedMedia);
  }

  public selectImage(media?: PropertyMediaInfo) {
    this.selectedMedia = media;
  }

  public navigate() {
    this.dialogRef.close();
    this.router.navigateByUrl(`/records/availability/${this.availabilityId}/attachments`);
  }
}
